import { EventItem } from './event-item.model';
import { Initiative } from './initiative.model';
import { User } from './user.model';

export interface Organization {
  id: number;
  creationDate: string;
  name: string;
  webToken: string;
  users: User[];
  initiatives: Initiative[];
  events: EventItem[];
}

export const nameRules = [
  (value: string) => {
    if (value) return true;

    return 'Name is required.';
  },
];
